import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import VariantService from '../../../../services/VariantService/VariantService';
import Logs from './Logs';
import { alertState } from "./../../../../recoil-store/recoil-state";
import { useSetRecoilState } from 'recoil';

/**
 * @Description This function returns Error section.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Errors({ error, setError, state, setState }) {

    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    const [log, setLog] = useState();
    const setAlert = useSetRecoilState(alertState);

    const handleRun = async () => {
        error.item.environment_target = 'local';
        const res = await VariantService.variantTestRun(error.item);
        if (res?.status) {
            error.item.test = 1;
            setError(null);
        } else {
            error.item.test = 2;
            setError({ ...error, res });
            setAlert(alert => ({ ...alert, show: true, message: res.message, severity: 'error' }))
        }
        setState({ ...state });
        return res?.status ? 1 : 2;
    };
    // const data = [{ desc: 'Your Variant-1 configuration doesn’t map to the Destination App Selected.' }];
    return (
        log ? <Logs error={log} setError={setLog} state={state} setState={setState} /> : <>
            <IconButton className="vtest-close" size="small" onClick={() => setError(false)}>
                <Close fontSize="small" />
            </IconButton>
            <div className="verror vh1">{t(label + 'YOUR-ACTION')}</div>
            <div className="verror">{t(label + 'ERROR')}</div>
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>{t(label + 'DESCRIPTION')}</th>
                        <th>{t(label + 'ACTIONS')}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {/* {data.map((item, itemI) => */}
                    <tr className="vvariable">
                        <td>{1}.</td>
                        <td>{error?.res?.message}</td>
                        <td>
                            <Button size="small" onClick={handleRun} style={{ whiteSpace: 'nowrap' }}>
                                {t(label + 'RETRY')}
                            </Button>
                        </td>
                        <td>
                            <Button size="small" onClick={() => setLog(error)} style={{ whiteSpace: 'nowrap' }}>
                                {t(label + 'VIEW-LOGS')}
                            </Button>
                        </td>
                    </tr>
                    {/* )} */}
                </tbody>
            </table>
        </>
    );
}
export default Errors;